/**
 * Function that reloads the ime entry page when the user clicks the modal button or close icon.
 * It reloads the page so the Addendum modal shows back the form.
 */
export function closeAddendumModal() {
	$( '.modal-form-addendum' ).on( 'click', '.close-modal-form-addendum', function redirect() {
		window.location.reload( false );
	});
}